
import { observable, action, } from 'mobx';
import { Injectable } from '@angular/core';
import { DataService } from '../services/data.service';
import { AngularFirestoreCollection } from '@angular/fire/firestore';

@Injectable({providedIn:'root'})
export class AutoCompleteStore {
    @observable data: Array<any> = [];
    @observable filterdata: Array<any> = [];
    @observable filterdatas: Array<any> = [];
    @observable collectionData: Array<any> = [];
    @observable singleData: any;
    @observable process: boolean = false;
    @observable deleteProcess: boolean = false;
    @observable loading: boolean = true;
    @observable empty: boolean = false;
    constructor(private ds: DataService) { }


    @action
    fetchAutoDataStudentCallBack(collection, callback) {
        this.ds.autoColelctionStudentRef(collection).valueChanges().subscribe(data => {
            this.filterdata = data;
            callback(data);
        })
    }


    @action
    async fetchSearchStudentCallback(collectionName: string, field: string, search: any, callback) {
        return this.ds.searchfilterStudentRef(collectionName, field, search).valueChanges().subscribe(docs => {
            this.filterdata = docs;
            callback(docs)
        });
    }

    @action
    fetchAutoDataCallBack(collection, callback) {
        this.ds.autoColelctionRef(collection).valueChanges().subscribe(data => {
            this.filterdata = data;
            callback(data);
        })
    }


    @action
    async fetchSearchCallback(collectionName: string, field: string, search: any, callback) {
        return this.ds.searchfilterRef(collectionName, field, search).valueChanges().subscribe(docs => {
            this.filterdata = docs;
            callback(docs)
        });
    }

    @action
    fetchAutoDataByCompanyCallBack(collection, companyKey, callback) {
        this.ds.autoColelctionByCompanyRef(collection, companyKey).valueChanges().subscribe(data => {
            this.filterdata = data;
            callback(data)
        })
    }

    
    
    @action
    async fetchSearchByCompanyCallback(collectionName: string, companyKey: string, field: string, search: any, callback) {
        return this.ds.searchfilterByCompanyRef(collectionName, companyKey, field, search).valueChanges().subscribe(docs => {
            this.filterdata = docs;
            callback(docs)
        });
    }



}


